import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TheBlend: Site = {
  id: 'theblend',
  logo: 'svg/theblend.svg',
  label: 'The Blend',
  analyticsName: 'theblend',
  hostname: 'theblendjournal.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
